import { render, staticRenderFns } from "./bots.vue?vue&type=template&id=3923f7c1&scoped=true"
import script from "./bots.vue?vue&type=script&lang=js"
export * from "./bots.vue?vue&type=script&lang=js"
import style0 from "./bots.vue?vue&type=style&index=0&id=3923f7c1&prod&scoped=true&lang=css"
import style1 from "./bots.vue?vue&type=style&index=1&id=3923f7c1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3923f7c1",
  null
  
)

export default component.exports